import { TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';

import { useOtpTable } from '@/components/modules/KYC/KYCOrder/components/Otp/hooks/useOtpTable';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const OtpTableHeader: React.FC = () => {
  const { classes, columns } = useOtpTable();

  return (
    <TableHead className={classes.root}>
      <TableRow>
        {columns.map((column) => (
          <TableCell key={column.name} align={column.align} width={column.colWidth ? column.colWidth : 'auto'}>
            <Font variant={'body2'} color={'textSecondary'}>
              <Text tId={column.label} />
            </Font>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
